import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";

export const HeaderProfileWrapper = styled.div`
  display: flex;
  .nameContainer {
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    margin-right: 16px;
    align-items: flex-end;
    align-self: center;

    ${responsive.MOBILE`
      margin-right: 8px;
      margin-left: 8px;
      display: none;
    `}

    ${responsive.TABLET_LANDSCAPE`
      display: none;
    `}
  }
  .initialNameBg {
    background-color: ${COLORS.primary_dark_blue7};
    height: 40px;
    border-radius: 10px;
    padding: 9px;
    display: flex;
    align-items: center;
    cursor: pointer;

    ${responsive.TABLET_LANDSCAPE`
      margin-left: 24px;  
    `}

    ${responsive.MOBILE`
      margin-left: 8px;
    `}
  }
  .initialName {
    color: ${COLORS.cirrus_white};
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
  }
  .img {
    margin-left: 28px;
    width: 24px;
    height: 24px;
  }
  .profileNameDesktop {
    line-height: 18px;
    color: ${COLORS.cirrus_black11};
    display: block;
    ${responsive.MOBILE`
       display:none
    `}
  }

  .lastLoginDesktop {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    margin-top: 4px;
    color: ${COLORS.cirrus_black7};
    display: block;
    ${responsive.MOBILE`
       display:none
    `}
  }
`;
